import { ITheme } from '.';

const defaultTheme: ITheme = {
  color: {
    body1: '#9A9A9A',
    body2: '#86621E',
    body3: '#7c4b14',
  },
  maxWidth: '1000px',
  referenceMaxWidth: 1000,
  mobilePadding: 30,
  mobileBreakpoint: 1024,
  aboutBreakpoint: 800,
};

export default defaultTheme;



// WEBPACK FOOTER //
// ./src/theme/default.ts